import React, { useEffect, useState } from 'react';
import { Sparkles, ArrowRight, HeartHandshake } from 'lucide-react';

/**
 * Consumer cross-promo: drives visitors who need a fundraising auctioneer
 * to our sister platform, charityfundraiser.com.
 */
export const CharityPromo = ({ compact = false }) => {
  const [cfCount, setCfCount] = useState('19,300+');

  useEffect(() => {
    fetch('https://charityfundraiser.com/api/auctioneers/count')
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d && d.display) setCfCount(d.display); })
      .catch(() => {});
  }, []);

  return (
    <section
      data-testid="charity-promo"
      className={`relative overflow-hidden rounded-2xl bg-gradient-to-br from-indigo-900 via-purple-900 to-indigo-800 text-white ${compact ? 'p-6' : 'p-8 sm:p-10'}`}
    >
      <div className="absolute -right-10 -top-10 opacity-10">
        <HeartHandshake className="w-48 h-48" />
      </div>
      <div className="relative flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 text-amber-300 text-sm font-semibold mb-3">
            <Sparkles className="w-4 h-4" /> ELITE FUNDRAISING PLATFORM
          </div>
          <h2 className={`font-bold mb-2 ${compact ? 'text-lg md:text-lg' : 'text-3xl sm:text-4xl'}`}>
            Need an auctioneer for a fundraiser, gala, or golf tournament?
          </h2>
          <p className="text-indigo-100 text-base">
            Our sister platform <strong>CharityFundraiser.com</strong> connects nonprofits with {cfCount} vetted
            benefit auctioneers — plus everything you need to run the event: online bidding, silent &amp; live
            auctions, fund-a-need paddle raises, ticketing, and live scoreboards.
          </p>
        </div>
        <a
          href="https://charityfundraiser.com"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="charity-promo-cta"
          className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-amber-400 text-indigo-950 font-bold rounded-full hover:bg-amber-300 transition-colors shadow-lg"
        >
          Explore CharityFundraiser.com <ArrowRight className="w-5 h-5" />
        </a>
      </div>
    </section>
  );
};
